import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useCrewWageScale, CrewWageScale } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<CrewWageScale>
    useData={useCrewWageScale}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
